const skillsOffice = [
    { text: 'Word', icon: 'skill_advanced.png'},
    { text: 'Excel', icon: 'skill_intermediate.png'},
    { text: 'Powerpoint', icon: 'skill_advanced.png'},
  ];
  
  export default skillsOffice;